import React, { Component } from 'react'
import { Menu, Icon, Sidebar } from 'semantic-ui-react'
import { MENU } from 'Menu'
import qs from 'query-string'
import { translate } from 'react-i18next'

class SideBar extends Component {

  constructor(props) {
    super(props);

    this.state = {
      currentlyExpanded: ""
    };

  }

  componentDidMount() {
    MENU.sidebar.forEach((entry) => {
      if (this.props.location.pathname.startsWith(entry.fullPath) && entry.fullPath.length > 1) {
        this.setState({ currentlyExpanded: entry.fullPath });
      }
    });
  }

  childIsActive = entry => this.props.location.pathname.startsWith(entry.fullPath) && this.props.location.pathname.length > entry.fullPath.length

  setHistory(path) {
    let dataParams = {};
    if (this.props.location.search) {
      let params = qs.parse(this.props.location.search);
      let found = false;
      if (params.dataSource) {
        dataParams.dataSource = params.dataSource;
        found = true;
      }
      if (params.timePeriod) {
        dataParams.timePeriod = params.timePeriod;
        found = true;
      }
      if (params.domain) {
        dataParams.domain = params.domain;
        found = true;
      }
      if (params.tid) {
        dataParams.tid = params.tid;
        found = true;
      }
      if (found) {
        path += "?" + qs.stringify(dataParams);
      }
    }
    this.props.history.push(path);
  }

  render = () =>  {
    const { t } = this.props;
    return (
      <Sidebar as={Menu} 
        animation="overlay" 
        direction="left"
        visible={this.props.menuVisible}
        vertical
      >
        {MENU.sidebar.map((entry, index) => {
          if (entry.children && entry.children.length > 0) {
            return (
              <Menu.Item
                link={this.state.currentlyExpanded !== entry.fullPath}
                as="div"
                onClick={() => {
                  if (entry.fullPath === this.state.currentlyExpanded) {
                    this.setState({ currentlyExpanded: "" });
                  } else {
                    this.setState({ currentlyExpanded: entry.fullPath });
                  }
                }}
                key={index}
                id={t(entry.title)}
              >
                {entry.icon && (
                  <Icon
                    className={entry.icon + (this.childIsActive(entry) ? " blue" : "")}
                  />
                )}
                {t(entry.title)}
                <Icon className={"right-set polycom arrow drop" + (this.state.currentlyExpanded === entry.fullPath ? " up": " down")} color="black" />
                {entry.fullPath === this.state.currentlyExpanded && 
                  (
                  <Menu.Menu>
                    {entry.children.map((child, innerIndex) => (
                      <Menu.Item
                        link
                        active={this.props.location.pathname === child.fullPath}
                        onClick={(e) => {
                          this.setHistory(child.fullPath);
                          e.stopPropagation();
                        }}
                        key={innerIndex}
                        id={t(child.title)}
                      >
                        {t(child.title)}
                      </Menu.Item>
                    ))}
                  </Menu.Menu>
                )}
              </Menu.Item>
            );
          } else {
            return (
              <Menu.Item
                link
                active={this.props.location.pathname === entry.fullPath}
                onClick={() => {
                  this.setHistory(entry.fullPath);
                }}
                key={index}
                id={t(entry.title)}
              >
                {entry.icon && <Icon className={entry.icon} />}
                {t(entry.title)} 
              </Menu.Item>
            );
          }
        })}
      </Sidebar>
    );
  };
}

export default translate()(SideBar);

